import { lazyGettext } from '@eb/lazy-gettext';
import {
    ACCOUNT_SETTINGS_URL,
    BASE_URL,
    CHANGE_PLAN_PATH,
} from '../../constants/main';

export default {
    breadcrumbs: {
        crumbs: [
            {
                path: ACCOUNT_SETTINGS_URL,
                label: lazyGettext('Account Settings'),
            },
            {
                path: `${BASE_URL}${CHANGE_PLAN_PATH}`,
                label: lazyGettext('Change Package'),
            },
            {
                path: '#',
                label: lazyGettext('Downgrade'),
            },
        ],
    },
};
